import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PopUpDialogTemplate from './PopUpDialogTemplate';
import Chips from '../../../Club/ChipBalance/Chips';
import classNames from 'classnames';
import { isMobileLandscape } from 'react-device-detect';
import { getTournamentBuyinInfo } from '../../../Club/Main/components/Tabs/components/TournamentCasino/helpers/getTournamentBuyinInfo';
import { useTranslation } from 'react-i18next';
import { getWallet } from '../../../../store/selectors';
import '../../../../assets/stylesheets/TournamentCasino/TournamentDialog.scss';

const TournamentRegisterDialog = ({ data, onClose, onConfirm, btnNames }) => {
  const { t } = useTranslation();
  const walletMain = useSelector(getWallet);
  const { currency: guaranteedCurrency, value: guaranteedValue } = data.guaranteed;
  const info = getTournamentBuyinInfo(data);
  const { chipValue } = info;
  const { allowPaymentMain, allowPaymentFPP } = info;
  const [payWithFPP, setPayWithFPP] = useState(!allowPaymentMain);


  const tournamentDialogRegisterClasses = classNames({
    'tournaments__popup': true,
    'tournament__dialog__register': true,
    'tournament__dialog__register--landscape': isMobileLandscape,
    'tournament__dialog__register--landscape--oneOfPaymentNotAllowed': !allowPaymentMain || !allowPaymentFPP
  })

  return (
    <React.Fragment>
      <div className={tournamentDialogRegisterClasses}>
        <div className="tournaments__popup__overlay tournaments__register__overlay" onClick={onClose} />
        <PopUpDialogTemplate
          /* will translate 'Tournament Registration'  */
          title={t('tournaments.tournamentRegistration')}
          iconName={'registration'}
          onConfirm={onConfirm}
          onClose={onClose}
          btnNames={btnNames}
          btnClasses={{ confirm: 'primary', cancel: 'secondary' }}
        >
          <div className="tournament-registration">
            <div className="tournament-registration__info-wrapper">
              <span className="tournament-registration__info-guaranted">$ 50 Guaranteed — Rebuy</span>
              <span className="tournament-registration__info-spin-limit">{info.limit}</span>
            </div>
            <div className="tournament-registration__price-wrapper">
              <div className="tournament-registration__price">
                <span className="tournament-registration__price-label">{t('tournaments.price')}</span>
                <div className="tournament-registration__price-value">
                  {chipValue({ margin: 4 })}
                </div>
              </div>
              <div className="tournament-registration__price">
                <span className="tournament-registration__price-label">{t('tournaments.mainBalance')}</span>
                <div className="tournament-registration__price-value">
                  <Chips margin={4} val={walletMain.balance} />
                </div>
              </div>
            </div>
          </div>
        </PopUpDialogTemplate>
      </div>
    </React.Fragment>
  );
};

export default TournamentRegisterDialog;
